/**
 * @typedef {{
 *   native_identifier: string,
 *   label: string|false,
 *   url: string,
 *   slug: string,
 *   icon: string|null,
 *   search_type: string|null,
 *   search_content: string|null,
 *   children: Array,
 *   metadata: Object
 * }} staticAppRouteType
 */

/**
 * @type {Array<staticAppRouteType>}
 */
export const STATIC_APP_ROUTES = [
    {
        native_identifier: 'main_oauth',
        label: false,
        url: 'oauth',
        slug: 'oauth',
        icon: null,
        search_type: null,
        search_content: null,
        children: [],
        metadata: {
            is_native: true,
        },
    },
    {
        native_identifier: 'main_search',
        label: false,
        url: 'recherche',
        slug: 'recherche',
        icon: null,
        search_type: null,
        search_content: null,
        children: [],
        metadata: {
            is_native: true,
        },
    },
    {
        native_identifier: 'main_newsletter_emailing',
        label: false,
        url: 'newsletter/emailing',
        slug: 'newsletter-emailing',
        icon: null,
        search_type: null,
        search_content: null,
        children: [],
        metadata: {
            is_native: true,
        },
    },
    {
        native_identifier: 'detail_maps',
        label: false,
        url: '%main_prospects%/{prospect}/maps',
        slug: 'maps',
        icon: null,
        search_type: null,
        search_content: null,
        children: [],
        metadata: {
            is_native: true,
        },
    },
    {
        native_identifier: 'detail_resume_tasks',
        label: false,
        url: '%detail_open_tasks%/resume',
        slug: 'resume',
        icon: null,
        search_type: null,
        search_content: null,
        children: [],
        metadata: {
            is_native: true,
        },
    },
    {
        native_identifier: 'detail_not_found',
        label: false,
        url: '%main_prospects%/{prospect}/*',
        slug: 'not-found',
        icon: null,
        search_type: null,
        search_content: null,
        children: [],
        metadata: {
            is_native: true,
        },
    },
    {
        native_identifier: 'main_not_found',
        label: false,
        url: '*',
        slug: 'not-found',
        icon: null,
        search_type: null,
        search_content: null,
        children: [],
        metadata: {
            is_native: true,
        },
    },
];

/**
 * Get route configuration from static routes by native identifier
 * @param {string} nativeIdentifier
 * @returns {staticAppRouteType|undefined}
 */
export function getRouteConfigByNativeIdentifier(nativeIdentifier) {
    return STATIC_APP_ROUTES.find(route => route.native_identifier === nativeIdentifier);
}
